export var ENTITY = "pricing";
export var REDUCER_KEY = "PRICING_V2";
export var BASE_PATH_ENTITY = "pricings";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    // V1 listed pricings newest-first (order: "createdAt DESC").
    defaultSort: [{ field: "createdAt", method: "DESC" }],
};
